import {Notyf} from "notyf";

document.addEventListener("DOMContentLoaded", function () {
  handleCookiePolicy();
  //handleMobileMenu();
  handleImageLazyLoading();
  // handleMenuTabs();
  handleStickyHeader();
  initializeNotifications();
  handleSessionMessages();
  handleParallaxImages();
});


function openMenu(id){

}

function applyTailwindClassesToSpecificImage(parallaxImages) {
  parallaxImages.forEach((image) => {
    if (image.id === 'expressYourselfBannerImage') {
      image.classList.add('absolute', 'inset-0', 'object-cover', 'object-[43%]');
    }
  });
}

function applyParallaxStyles(parallaxImages) {
  parallaxImages.forEach((image) => {
    const parent = image.parentElement;
    parent.style.backgroundImage = `url(${image.getAttribute('data-src')})`;
    parent.style.backgroundSize = 'cover';
    parent.style.backgroundPosition = 'center';
    parent.style.backgroundRepeat = 'no-repeat';
    parent.style.backgroundAttachment = 'fixed';
    parent.style.height = image.style.height;
    image.remove();
  });
}

function handleParallaxImages() {
  const parallaxImages = document.querySelectorAll('.parallax-image');

  isIOSDevice() ? applyTailwindClassesToSpecificImage(parallaxImages) : applyParallaxStyles(parallaxImages);
}

function isIOSDevice() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod",
  ].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}

function handleCookiePolicy() {
  window.onload = function () {
    const policyCookie = getCookie("ecommerce_cookie_policy");

    if (policyCookie == null) {
      document.getElementById("cookie-policy").style.display = "block";
    } else {
      document.getElementById("cookie-policy").style.display = "none";
    }
  };
}


function handleImageLazyLoading() {
  yall({
    observeChanges: true,
  });
}

function handleMobileMenu() {
  console.log('aaa')
  const body = document.body;
  const mainMenuToggler = document.getElementById("main-menu-toggler");
  const closeButton = document.getElementById("close-menu");
  const mobileMenu = document.getElementById("mobile-menu");

  mobileMenu.classList.remove("hidden");

  mainMenuToggler.addEventListener("click", () => {
    mobileMenu.classList.remove("-translate-x-full");
    body.style.overflowY = "hidden";
  });
  closeButton.addEventListener("click", function () {
    mobileMenu.classList.add("-translate-x-full");
    body.style.overflowY = "auto";
  });
}

function handleStickyHeader() {
  let lastScrollPosition=0
  const header = document.getElementById("sticky-header");
  const headerLogo = document.getElementById("header-logo");
  const desktopMenu = document.getElementById("desktop-menu");
  const mobileMenuToggler = document.getElementById("main-menu-toggler");
  if (window._isHomePage) {
    window.addEventListener("scroll", function (e) {

      let isScrollingUp=window.scrollY<lastScrollPosition
      lastScrollPosition=window.scrollY
      let soundButton=document.querySelector('#hero-sound-button')

      if (window.scrollY > 33 && isScrollingUp ) {
        header.classList.add("bg-white",'fixed', "top-0", "border-b", "border-lightest-gray",'text-black','custom-box-shadow');
        header.classList.remove("bg-transparent","absolute", "top-[33px]",'text-white','header-background-shadow' ,'h-[150px]');

        headerLogo.src=headerLogo.dataset.blackLogo
        soundButton.classList.add('hidden')
        if (mobileMenuToggler) {
          mobileMenuToggler.classList.add("text-black");
          mobileMenuToggler.classList.remove("text-white");
        }
      } else {
        header.classList.remove("bg-white", "top-0",'fixed', "border-b", "border-lightest-gray",'text-black','custom-box-shadow');
        header.classList.add("bg-transparent","absolute",'text-white','header-background-shadow' );
        headerLogo.src=headerLogo.dataset.whiteLogo
        soundButton.classList.remove('hidden')

        if (mobileMenuToggler) {
          mobileMenuToggler.classList.add("text-white");
          mobileMenuToggler.classList.remove("text-black");
        }
      }
    });
  }else{

    window.addEventListener("scroll", function (e) {

      let isScrollingUp=window.scrollY<lastScrollPosition
      lastScrollPosition=window.scrollY
      console.log(window.scrollY)
      if (window.scrollY > 33 && isScrollingUp ) {
        header.classList.add("bg-white",'fixed', "border-b", "border-lightest-gray");
        header.classList.remove("bg-transparent","absolute",'relative');
      } else if (window.scrollY > 33) {
        header.classList.add("bg-transparent",'absolute');
        header.classList.remove("bg-white",'fixed', "border-b", "border-lightest-gray");
      }else{
        header.classList.add("bg-transparent",'relative');
        header.classList.remove("bg-white",'fixed','absolute', "border-b", "border-lightest-gray");
      }
    });

  }
}



function handleMenuTabs() {
  const shopTab = document.getElementById("shop-tab");
  const aboutTab = document.getElementById("about-tab");
  const profileTab = document.getElementById("profile-tab");
  const shopMenu = document.getElementById("shop-menu");
  const aboutMenu = document.getElementById("about-menu");
  const profileMenu = document.getElementById("profile-menu");

  shopTab.addEventListener("click", function () {
    shopMenu.classList.remove("hidden");
    aboutMenu.classList.add("hidden");
    profileMenu.classList.add("hidden");
    shopTab.classList.remove("border-transparent");
    shopTab.classList.add("border-black");
    aboutTab.classList.remove("border-black");
    aboutTab.classList.add("border-transparent");
    profileTab.classList.remove("border-black");
    profileTab.classList.add("border-transparent");
  });

  aboutTab.addEventListener("click", function () {
    aboutMenu.classList.remove("hidden");
    shopMenu.classList.add("hidden");
    profileMenu.classList.add("hidden");
    aboutTab.classList.remove("border-transparent");
    aboutTab.classList.add("border-black");
    shopTab.classList.remove("border-black");
    shopTab.classList.add("border-transparent");
    profileTab.classList.remove("border-black");
    profileTab.classList.add("border-transparent");
  });

  profileTab.addEventListener("click", function () {
    profileMenu.classList.remove("hidden");
    shopMenu.classList.add("hidden");
    aboutMenu.classList.add("hidden");
    profileTab.classList.remove("border-transparent");
    profileTab.classList.add("border-black");
    shopTab.classList.remove("border-black");
    shopTab.classList.add("border-transparent");
    aboutTab.classList.remove("border-black");
    aboutTab.classList.add("border-transparent");
  });
}

function initializeNotifications() {
  window.notyf = new Notyf({
    duration: 3000,
    ripple: true,
    dismissible: true,
    position: {
      x: "right",
      y: "bottom",
    },
  });
}

function handleSessionMessages() {
  ['success', 'error'].forEach(type => {
    const messageElement = document.getElementById(`${type}-message`);
    if (messageElement) {
      notyf[type](messageElement.textContent);
      messageElement.remove();
    }
  });
}

function getCookie(name) {
  const match = document.cookie.match(RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

window.fireQuickView = function (event) {
  if (window.isSidebarOpen) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  event.target.dispatchEvent(new CustomEvent("quick-view", {
    bubbles: true,
    detail: {
      productId: parseInt(event.target.dataset.productId),
    },
  }));
};

window.openProductDetails = function (event) {
  if (window.isSidebarOpen) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  event.target.dispatchEvent(new CustomEvent("view-product-details", {
    bubbles: true,
  }));
};

window.openDeliveryInfo = function (event) {
  if (window.isSidebarOpen) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  event.target.dispatchEvent(new CustomEvent("view-delivery-info", {
    bubbles: true,
  }));
};

window.copyCurrentUrl = function (event) {
  const element = event.currentTarget;
  const url = element.getAttribute("data-url");

  navigator.clipboard.writeText(url)
    .then(() => {
      const message = element.querySelector("span");
      message.classList.remove("hidden");
      setTimeout(() => message.classList.add("hidden"), 2000);
    })
    .catch(err => {
      console.error("Failed to copy URL: ", err);
    });
};

window.handleShareButton = async function (event, title, text) {
  try {
    if (navigator.share) {
      await navigator.share({
        title: title,
        text: text,
        url: window.location.href,
      });
    } else {
      copyCurrentUrl(event);
    }
  } catch (error) {
    console.error("Error sharing:", error.message);
  }
};

window.openNewsletterModal = () => {
  document.getElementById("newsletter-modal").classList.remove("hidden");
  document.getElementById("newsletter-modal").classList.add("flex");

  document.body.style.overflow = "hidden";
};

window.closeNewsletterModal = () => {
  document.getElementById("newsletter-modal").classList.add("hidden");
  document.getElementById("newsletter-modal").classList.remove("flex");

  document.body.style.overflow = "auto";
};

window.toggleFavoriteProduct = async function (event) {
  if (window.isSidebarOpen) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  const element = event.target;
  const url = element.getAttribute("data-url");
  const shouldRemove = element.getAttribute("data-remove") === "true";

  const response = await fetch(url, {
    method: "POST",
    withCredentials: true,
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content"),
    },
  });

  const data = await response.json();

  if (data.favorite) {
    element.classList.add("text-black");
    element.classList.remove("text-transparent", "hover:text-black");
    notyf.success(Array.isArray(_translations[_locale]) ? "Product added to favourites" : _translations[_locale]["Product added to favourites"]);
  } else {
    element.classList.add("text-transparent", "hover:text-black");
    element.classList.remove("text-black");
    notyf.success(Array.isArray(_translations[_locale]) ? "Product removed from favourites" : _translations[_locale]["Product removed from favourites"]);

    if (shouldRemove) {
      element.parentElement.parentElement.remove();
    }
  }
};

window.handleLoadMore = async function (event) {
  event.preventDefault();
  event.stopPropagation();

  const element = event.target;

  const page = parseInt(element.getAttribute("data-page"));
  const perPage = parseInt(element.getAttribute("data-per-page"));
  const total = parseInt(element.getAttribute("data-total"));
  const url = element.getAttribute("data-url");
  const target = element.getAttribute("data-target");

  const response = await fetch(`${url}?page=${page}`, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  });

  const html = await response.text();

  document.querySelector(target).insertAdjacentHTML("beforeend", html);

  if (page * perPage >= total) {
    element.parentElement.remove();
  } else {
    element.setAttribute("data-page", (page + 1).toString());
  }
};

// Functions to open and close header dropdowns
window.openDropdown = function(id) {
  const menu = document.getElementById('desktop-menu');
  const sideBarOptions = document.getElementById('desktop-menu-sidebar-options');
  const sideBarContent = document.getElementById('desktop-menu-content');
  document.body.style.overflow = "hidden";
  menu.classList.remove("hidden");

  [...sideBarOptions.children].forEach(child => {
    child.classList.replace("opacity-100", "opacity-60");
    child.children[1].classList.add('hidden');
  });

  const selectedOption = document.getElementById(`desktop-menu-sidebar-options-${id}`);
  selectedOption.classList.replace("opacity-60", "opacity-100");
  selectedOption.children[1].classList.remove('hidden');

  [...sideBarContent.children].forEach(child => child.classList.add("hidden"));

  document.getElementById(`desktop-menu-content-${id}`).classList.remove("hidden");
};

window.closeDropdown = function (id) {
  document.getElementById('desktop-menu').classList.add("hidden");
  document.body.style.overflow = "visible";

};

window.initHomeSlider = function initHomeSlider() {
  return tns({
    container: ".home-slider",
    items: 1,
    slideBy: 1,
    mouseDrag: true,
    nav: false,
    navPosition: "bottom",
    controls: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayButtonOutput: false,
  });
};
